import { PortableText } from '@portabletext/react';
import { FC } from 'react';

import { captionPortableTextComponents } from '@/src/assets/PTComponents/portableTextComponents';
import { BlogTagInterface } from '@/src/assets/interfaces/blogTagInterface';
import { ImageInterface } from '@/src/assets/interfaces/imageInterface';
import { getImageUrl } from '@/src/assets/utils/getImageUrl';
import { getUpdateDate } from '@/src/assets/utils/getUpdateDate';

import NextImage from '../../UI/nextImage/NextImage';
import Wrapper from '../../UI/wrapper/Wrapper';
import Breadcrumbs from '../../breadcrumbs/Breadcrumbs';
import { ShareBlock } from '../blogPostShareBlock/BlogPostShareBlock';
import { BlogPostTag } from '../blogPostTag/BlogPostTag';

import styles from './BlogPostHead.module.scss';

interface BlogPostHeadProps {
    title: string;
    excerpt: string;
    updateDate: string;
    tags?: BlogTagInterface[];
    slug: string;
    estimatedReadingTime: number;
    featureImage: ImageInterface;
}

const BlogPostHead: FC<BlogPostHeadProps> = ({
    title,
    excerpt,
    updateDate,
    tags,
    slug,
    estimatedReadingTime,
    featureImage,
}) => {
    const readingTime =
        estimatedReadingTime === 0 || estimatedReadingTime === 1
            ? 'Only a minute read'
            : `${estimatedReadingTime} minutes read`;
    return (
        <Wrapper className={styles.postHeadWrapper}>
            <Breadcrumbs />
            <div className={styles.postHead}>
                {!!tags && (
                    <div className={styles.postHeadTags}>
                        {tags.map((tag) => {
                            return <BlogPostTag key={tag._id} tag={tag} />;
                        })}
                    </div>
                )}
                <div className={styles.postHeadInfo}>
                    {/* <span className={styles.postHeadInfo__date}>{getUpdateDate(updateDate)}</span> */}
                    <span className={styles.postHeadInfo__readTime}>{readingTime}</span>
                </div>
                <h1 className={styles.postTitle}>{title}</h1>
                <p className={styles.postExcerpt}>{excerpt}</p>
                <ShareBlock postSlug={slug} className={styles.postHeadShareBlock} />
            </div>
            {featureImage.caption?.length ? (
                <figure className={styles.featureImageFigure}>
                    <NextImage
                        src={getImageUrl(featureImage)}
                        fill={true}
                        alt={featureImage.alt || "Post's feature image"}
                        quality={90}
                        priority={true}
                        sizes="(max-width: 1280px) 95vw, (min-width: 1281px) 1184px"
                        className={styles.postFeatureImage}
                    />
                    <figcaption className={styles.featureImageFigure__figcaption}>
                        <PortableText
                            value={featureImage.caption}
                            components={captionPortableTextComponents}
                        />
                    </figcaption>
                </figure>
            ) : (
                <NextImage
                    src={getImageUrl(featureImage)}
                    fill={true}
                    alt={featureImage.alt || "Post's feature image"}
                    quality={90}
                    priority={true}
                    sizes="(max-width: 1280px) 95vw, (min-width: 1281px) 1184px"
                    className={styles.postFeatureImage}
                />
            )}
        </Wrapper>
    );
};

export { BlogPostHead };
